'use strict';

exports.__esModule = true;

var _Chart = require('./components/Chart');

var _Chart2 = _interopRequireDefault(_Chart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Chart: _Chart2.default };
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-google-charts/lib/index.js
// module id = 265
// module chunks = 0